package com.exura.features.newauth.domain.model

enum class ProviderUserRole(val authRole: UserRole) {
    DOCTOR(UserRole.DOCTOR),
    ORGANIZATION(UserRole.ORGANIZATION),
    STAFF(UserRole.STAFF);
}
